import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "Born in Ethiopia",
    text: "Named after Adulis — the ancient Red Sea port that connected Africa to the world — our platform starts in Ethiopia and is built to serve the entire continent. African engineers, African ownership, African destiny.",
  },
  {
    num: "02",
    title: "Open by design",
    text: "Like MOSIP before us, every line of Adulis is open source. No vendor lock-in, no black boxes. Governments and institutions can inspect, adapt, and extend the platform freely — forever.",
  },
  {
    num: "03",
    title: "Identity as a right",
    text: "Hundreds of millions of Africans lack a foundational legal identity. Adulis exists to close that gap — with privacy-preserving, inclusive digital ID that unlocks services, finance, and dignity.",
  },
];

const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative px-6 sm:px-12 py-32 sm:py-44">
    <div className="flex items-center gap-4 mb-20">
      <span className="h-px w-16 bg-clay" />
      <span className="text-xs uppercase tracking-[0.3em] font-bold text-gold">The Manifesto</span>
    </div>

    <div className="grid lg:grid-cols-12 gap-16">
      <div className="lg:col-span-5">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
          className="relative z-10 font-display font-bold text-4xl sm:text-5xl tracking-tight leading-tight lg:sticky lg:top-32 glass-panel p-8"
        >
          A continent deserves infrastructure it <span className="text-clay">owns</span>.
        </motion.h2>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.3 }}
          className="mt-12 overflow-hidden border border-line"
        >
          <img
            src="https://images.unsplash.com/photo-1580320209809-a0c51e645872?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            alt="Ethiopian landscape at sunset"
            className="w-full h-72 object-cover hover:scale-105 transition-transform duration-[1.5s]"
          />
        </motion.div>
      </div>

      <div className="lg:col-span-7 flex flex-col gap-24">
        {chapters.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`manifesto-chapter-${c.num}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: i * 0.1, ease: [0.65, 0, 0.35, 1] }}
            className="relative pl-8 sm:pl-0"
          >
            <span className="font-display font-bold text-8xl sm:text-9xl text-outline absolute -top-10 -left-2 sm:-left-10 select-none" aria-hidden="true">
              {c.num}
            </span>
            <div className="relative glass-panel p-8 sm:p-10">
              <h3 className="font-display font-bold text-2xl sm:text-3xl tracking-tight mb-5">{c.title}</h3>
              <p className="text-base md:text-lg text-ink-dim leading-relaxed max-w-xl">{c.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
